/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PinterestIntegrationAdAccountData
 */
export interface PinterestIntegrationAdAccountData {
    /**
     * 
     * @type {string}
     * @memberof PinterestIntegrationAdAccountData
     */
    accountId?: string;
    /**
     * 
     * @type {string}
     * @memberof PinterestIntegrationAdAccountData
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PinterestIntegrationAdAccountData
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PinterestIntegrationAdAccountData
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof PinterestIntegrationAdAccountData
     */
    timeZone?: string;
    /**
     * 
     * @type {string}
     * @memberof PinterestIntegrationAdAccountData
     */
    status?: string;
}

/**
 * Check if a given object implements the PinterestIntegrationAdAccountData interface.
 */
export function instanceOfPinterestIntegrationAdAccountData(value: object): value is PinterestIntegrationAdAccountData {
    return true;
}

export function PinterestIntegrationAdAccountDataFromJSON(json: any): PinterestIntegrationAdAccountData {
    return PinterestIntegrationAdAccountDataFromJSONTyped(json, false);
}

export function PinterestIntegrationAdAccountDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PinterestIntegrationAdAccountData {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'] == null ? undefined : json['accountId'],
        'name': json['name'] == null ? undefined : json['name'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'timeZone': json['timeZone'] == null ? undefined : json['timeZone'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function PinterestIntegrationAdAccountDataToJSON(json: any): PinterestIntegrationAdAccountData {
    return PinterestIntegrationAdAccountDataToJSONTyped(json, false);
}

export function PinterestIntegrationAdAccountDataToJSONTyped(value?: PinterestIntegrationAdAccountData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountId': value['accountId'],
        'name': value['name'],
        'enabled': value['enabled'],
        'currency': value['currency'],
        'timeZone': value['timeZone'],
        'status': value['status'],
    };
}

